import axios from 'axios';

export const API_BASE = process.env.REACT_APP_BACKEND_URL;
export const api = axios.create({ baseURL: `${API_BASE}/api`, withCredentials: true });
export const errMsg = (err, fallback = 'Something went wrong. Please try again.') => err?.response?.data?.detail || fallback;
